// extracted by mini-css-extract-plugin
module.exports = {"btnImgUrlSize":"verifyemailform_btnImgUrlSize__12z7W","btnImgUrlText":"verifyemailform_btnImgUrlText__QPX7c"};